"use strict";
/* tslint:disable:completed-docs */
Object.defineProperty(exports, "__esModule", { value: true });
var jsu = require("handle-events");
exports.on = function (target, eventns, listener, capture) {
    jsu.addEventListener(target, eventns, listener, capture);
};
exports.onDelegate = function (target, eventns, selector, listener, capture) {
    jsu.delegate(target, eventns, selector, listener, capture);
};
exports.one = function (target, eventns, listener, capture) {
    var wrapped = function (event) {
        jsu.removeEventListener(target, eventns, wrapped);
        listener(event);
    };
    jsu.addEventListener(target, eventns, wrapped, capture);
};
exports.oneDelegate = function (target, eventns, selector, listener, capture) {
    var wrapped = function (event) {
        jsu.removeEventListener(target, eventns, wrapped);
        listener(event);
    };
    jsu.delegate(target, eventns, selector, wrapped, capture);
};
exports.off = function (target, eventns, listener) {
    jsu.removeEventListener(target, eventns, listener);
};
exports.events = function (target, ns) {
    var createEventNamespace = function (given) {
        return ns !== undefined ? given + "." + ns : given;
    };
    var instance = {
        on: function (eventns, listener, capture) {
            exports.on(target, createEventNamespace(eventns), listener, capture);
            return instance;
        },
        onDelegate: function (eventns, selector, listener, capture) {
            exports.onDelegate(target, createEventNamespace(eventns), selector, listener, capture);
            return instance;
        },
        one: function (eventns, listener, capture) {
            exports.one(target, createEventNamespace(eventns), listener, capture);
            return instance;
        },
        oneDelegate: function (eventns, selector, listener, capture) {
            exports.oneDelegate(target, createEventNamespace(eventns), selector, listener, capture);
            return instance;
        },
        off: function (eventns, listener) {
            exports.off(target, eventns !== undefined ? createEventNamespace(eventns) : eventns, listener);
            return instance;
        },
    };
    return instance;
};
